import { UserPagePathBuilder } from '@user/pages/UserPagePathBuilder';

type Props = {
  groupId: string;
  tagId: string;
  tagName: string;
};

export const SearchViewModelTagItem: React.FC<Props> = ({ groupId, tagId, tagName }: Props) => {
  return (
    <span className="mx-1 mb-1 rounded-md border border-gray-500 px-1 text-[0.7rem]">
      <a
        href={UserPagePathBuilder.tagAssignedViewModelsPage(groupId, tagId)}
        className="font-bold hover:underline"
        target="_blank"
        rel="noreferrer"
      >
        {tagName}
      </a>
    </span>
  );
};
